export default __webpack_public_path__ + "static/media/smart-02.af2a4e81.jpg";